// extracted by mini-css-extract-plugin
export default {"root":"iprTxDT6fC","root_notVisibleOnMobile":"ndpvr5jal5"};